export default "__VITE_PUBLIC_ASSET__4e14d2d1__"